import { createRouter, createWebHistory } from 'vue-router';
import {route} from "ziggy-js";
import { PRICING_ROUTE } from "../consts/PricingRouteNames";
import { handleChunkLoadError } from "../utils/chunkErrorHandler";

const routes = [
    {
        path: relativeUrlFromRoute("pricing.businessApi"),
        name: PRICING_ROUTE.BUSINESS_API,
        component: () => import(/* webpackChunkName: "pricing-subpage" */ './components/PricingPage/subpages/Pricing.vue'),
    },
    {
        path: relativeUrlFromRoute("pricing.individualReports"),
        name: PRICING_ROUTE.INDIVIDUAL_REPORTS,
        component: () => import(/* webpackChunkName: "pricing-reports-subpage" */ './components/PricingPage/subpages/PricingReports.vue'),
    },
    {
        path: relativeUrlFromRoute("pricing.checkout"),
        name: PRICING_ROUTE.CHECKOUT,
        component: () => import(/* webpackChunkName: "checkout-subpage" */ './components/PricingPage/subpages/Checkout.vue'),
    },
];

const vueRouter = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { top: 0 };
    },
});

vueRouter.onError((error) => {
    handleChunkLoadError(error);
});

/**
 * Converts absolute path identified by route name defined in Laravel's routes to relative path used by vue router
 *
 * @param {String} routeName Name of route in Laravel
 *
 * @returns {String} Relative path
 */
export function relativeUrlFromRoute(routeName) {
    return route(routeName).replace(/^[a-zA-Z]+:\/\/[^\/]+/, '');
}

export default vueRouter;
